import React from 'react';

const PLATFORM_META = {
  SGJOGO: {
    logo: '/assets/platforms/sgjogo.png',
    prefix: 'SG',
    suffix: 'JOGO',
    suffixClass: 'text-green-400',
  },
  XGJOGO: {
    logo: '/assets/platforms/xgjogo.png',
    prefix: 'XG',
    suffix: 'JOGO',
    suffixClass: 'text-sky-400',
  },
  HGJOGO: {
    logo: '/assets/platforms/hgjogo_cta.jpg',
    prefix: 'HG',
    suffix: 'JOGO',
    suffixClass: 'text-cyan-400',
  },
  FGJOGO: {
    logo: '/assets/platforms/fgjogo_logo.png',
    prefix: 'FG',
    suffix: 'JOGO',
    suffixClass: 'text-pink-500',
  },
  VGJOGO: {
    logo: '/assets/platforms/vgjogo.png',
    prefix: 'VG',
    suffix: 'JOGO',
    suffixClass: 'text-violet-400',
  },
  EGJOGO: {
    logo: '/assets/platforms/egjogo.png',
    prefix: 'EG',
    suffix: 'JOGO',
    suffixClass: 'text-orange-400',
  },
  MGJOGO: {
    logo: '/assets/platforms/mgjogo.png',
    prefix: 'MG',
    suffix: 'JOGO',
    suffixClass: 'text-teal-400',
  },
  WGJOGO: {
    logo: '/assets/platforms/wgjogo.png',
    prefix: 'WG',
    suffix: 'JOGO',
    suffixClass: 'text-blue-400',
  },
  AGJOGO: {
    logo: '/assets/platforms/agjogo.png',
    prefix: 'AG',
    suffix: 'JOGO',
    suffixClass: 'text-red-400',
  },
  BGJOGO: {
    logo: '/assets/platforms/bgjogo.png',
    prefix: 'BG',
    suffix: 'JOGO',
    suffixClass: 'text-indigo-400',
  },
  YGJOGO: {
    logo: '/assets/platforms/ygjogo.png',
    prefix: 'YG',
    suffix: 'JOGO',
    suffixClass: 'text-yellow-400',
  },
  DGJOGO: {
    logo: '/assets/platforms/dgjogo.png',
    prefix: 'DG',
    suffix: 'JOGO',
    suffixClass: 'text-purple-400',
  },
};

const Header = ({ selectedPlatform, onBackToPlatforms }) => {
  const meta = PLATFORM_META[selectedPlatform] || PLATFORM_META.FGJOGO;

  return (
    <header className="sticky top-0 z-50 bg-[#0a0a0a]/80 backdrop-blur-xl border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <button 
            onClick={onBackToPlatforms} 
            data-testid="back-to-platforms-btn"
            className="flex items-center gap-2 min-h-[44px] pr-3 -ml-1 pl-1 rounded-lg text-gray-400 hover:text-white transition-colors"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 19l-7-7 7-7" />
            </svg>
            <span className="text-sm">Voltar</span>
          </button>

          <div className="flex items-center gap-2">
            <img src={meta.logo} alt={`${meta.prefix} ${meta.suffix}`} className="w-10 h-10 rounded-lg object-cover" />
            <span className="text-lg font-bold">
              <span className="text-white">{meta.prefix}</span>
              <span className={meta.suffixClass}> {meta.suffix}</span>
            </span>
          </div>

          <img src={meta.logo} alt={`${meta.prefix} ${meta.suffix}`} className="w-9 h-9 rounded-lg object-cover opacity-80" />
        </div>
      </div>
    </header>
  );
};

export default Header;
